import ApiBase from './base/ApiBase'
import { BaseEntity, OngoingAssessment, OngoingAssessmentDisplay, OngoingAssessmentGraph, ProficiencyType } from '../models/dtos';

export enum MockFilterType {
    Exclude = "Exclude",
    Include = "Include",
    MockOnly = "Only",
}

class OngoingAssessmentClient extends ApiBase {
    private controllerName: string = 'OngoingAssessment';

    async Create(dto: CreateOngoingAssessment, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}`, dto, signal);
    }

    async Delete(id: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetAllDisplay(filter: MockFilterType, signal?: AbortSignal): Promise<OngoingAssessmentDisplay[]> {
        let url = (filter === MockFilterType.Exclude) ? `${this.controllerName}/Display` : `${this.controllerName}/Display?mockFilter=${filter}`;
        return this.GetAsync(url, signal);
    }

    async GetMyTalent(signal?: AbortSignal): Promise<OngoingAssessmentDisplay[]> {
        return this.GetAsync(`${this.controllerName}/MyTalent`, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<OngoingAssessment> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetSingleByTalent(talentId: string, signal?: AbortSignal): Promise<OngoingAssessment> {
        return this.GetAsync(`${this.controllerName}/Talent/${talentId}`, signal);
    }

    async GetSingleDisplay(id: string, signal?: AbortSignal): Promise<OngoingAssessmentDisplay> {
        return this.GetAsync(`${this.controllerName}/${id}/Display`, signal);
    }

    async GetSingleGraph(id: string, signal?: AbortSignal): Promise<OngoingAssessmentGraph> {
        return this.GetAsync(`${this.controllerName}/${id}/Graph`, signal);
    }

    async GetSingleGraphByTalent(talentId: string, signal?: AbortSignal): Promise<OngoingAssessmentGraph> {
        return this.GetAsync(`${this.controllerName}/Talent/${talentId}/Graph`, signal);
    }

    async Update(dto: OngoingAssessment, signal?: AbortSignal): Promise<void> {
        return this.PutAsync(`${this.controllerName}/${dto.Id}`, dto, signal);
    }
}


export class CreateOngoingAssessmentProficiency{ 
    OngoingAssessmentId: string; 
    ProficiencyGroupId: string; 
    ProficiencyId?: string | null; 
    Type?: ProficiencyType; 
    Name?: string; 
    Weight?: number; 
    IsNegative?: boolean; 
    }

export interface CreateOngoingAssessment {
    TemplateId: string;
    AssociationId?: string;
    IsMock: boolean;
}

export interface OngoingAssessmentProficiency extends BaseEntity{
    OngoingAssessmentId: string;
    ProficiencyId: string;
    Selection: string;
    Notes: string;
}

export enum OngoingAssessmentErrors {
    Create = 'Error creating OngoingAssessment',
    Delete = 'Error deleting OngoingAssessment',
    GetAll = 'Error loading Proficiencies',
    GetSingle = 'Error loading OngoingAssessment',
    Update = 'Error saving OngoingAssessment',
    Publish = 'Error publishing OngoingAssessment',
    Validate = 'Assessment Validation Finding(s)',
}

export default OngoingAssessmentClient;